import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './LoadingPlaceholder.css';
import { ToggleButton, ThreeLoadingDots } from '../widgets';

const LoadingPlaceholder = ({
    loadingText = '',
    readyText = '',
    buttonText = '',
    state = LoadingPlaceholder.LOADING,
    className = '',
    onReadyClick = () => {},
}) => {
    return (
        <div className={`${css.container} ${className}`}>
            {state === LoadingPlaceholder.LOADING ? (
                <div>
                    <Translate id={loadingText} />
                    <ThreeLoadingDots />
                </div>
            ) : null}
            {state === LoadingPlaceholder.READY ? (
                <div className={css.readyContainer}>
                    <div className={css.readyText}>
                        <Translate id={readyText} />
                    </div>
                    <ToggleButton text={buttonText} showIcon={false} onClick={onReadyClick} />
                </div>
            ) : null}
        </div>
    );
};

LoadingPlaceholder.READY = 0;
LoadingPlaceholder.LOADING = 1;

LoadingPlaceholder.propTypes = {
    state: PropTypes.oneOf([LoadingPlaceholder.READY, LoadingPlaceholder.LOADING]),
    loadingText: PropTypes.string,
    readyText: PropTypes.string,
    buttonText: PropTypes.string,
    onReadyClick: PropTypes.func,
    className: PropTypes.string,
};

export default LoadingPlaceholder;
